import { useEffect, useState } from "react";
import { Body, Button, Day, Frame, Header } from "./CalendarStyle.styled";
import { ArrowLeft, ArrowRight } from "./Icons/Icons";

interface CalenderTaskProps {
  onChange?: (date: Date) => void;
  value?: Date;
}

export const Calendar: React.FC<CalenderTaskProps> = ({ onChange, value }) => {
  const DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const DAYS_OF_THE_WEEK = ["M", "T", "W", "T", "F", "S", "S"];
  const MONTHS = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const getStartDayOfMonth = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), 1).getDay();

  const today = new Date();
  const [date, setDate] = useState(value || today);
  const [day, setDay] = useState(date.getDate());
  const [month, setMonth] = useState(date.getMonth());
  const [year, setYear] = useState(date.getFullYear());
  const [startDay, setStartDay] = useState(getStartDayOfMonth(date));

  useEffect(() => {
    if (value) setDate(value); // синхронізація зі зовнішнім value
  }, [value]);

  useEffect(() => {
    setDay(date.getDate());
    setMonth(date.getMonth());
    setYear(date.getFullYear());
    setStartDay(getStartDayOfMonth(date));
  }, [date]);

  const isLeapYear = (y: number) =>
    (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
  const days = isLeapYear(year) ? DAYS_LEAP : DAYS;

  const isPastDay = (y: number, m: number, d: number) => {
    const todayDate = new Date();
    return (
      new Date(y, m, d) <
      new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        todayDate.getDate()
      )
    );
  };

  const handleDateChange = (selectedDate: Date) => {
    setDate(selectedDate);
    if (onChange) onChange(selectedDate);
  };

  return (
    <Frame>
      <Header>
        <Button
          onClick={() => {
            const prevMonth = new Date(year, month - 1, day);
            if (prevMonth >= new Date(today.getFullYear(), today.getMonth(), 1))
              setDate(prevMonth);
          }}
          style={{
            opacity:
              month === today.getMonth() && year === today.getFullYear()
                ? 0.5
                : 1,
          }}
        >
          <ArrowLeft />
        </Button>

        <div>
          {MONTHS[month]} {year}
        </div>

        <Button onClick={() => setDate(new Date(year, month + 1, day))}>
          <ArrowRight />
        </Button>
      </Header>

      <Body>
        {DAYS_OF_THE_WEEK.map((d, i) => (
          <Day key={i}>
            <strong>{d}</strong>
          </Day>
        ))}

        {Array(days[month] + (startDay - 1))
          .fill(null)
          .map((_, index) => {
            const d = index - (startDay - 2);

            if (d <= 0) return <Day key={index}></Day>;

            const disabled = isPastDay(year, month, d);
            const isSelected =
              date.getDate() === d &&
              date.getMonth() === month &&
              date.getFullYear() === year;
            const isToday =
              d === today.getDate() &&
              month === today.getMonth() &&
              year === today.getFullYear();

            return (
              <Day
                key={index} // ← ДОДАЙ ЦЕ!
                $isToday={isToday}
                $isSelected={isSelected}
                $isDisabled={disabled}
                onClick={() =>
                  !disabled && handleDateChange(new Date(year, month, d))
                }
              >
                {d}
              </Day>
            );
          })}
      </Body>
    </Frame>
  );
};
